import React from "react"; 
import OrderCargoBarcodesListPageContainer from "./OrderCargoBarcodesListPageContainer";
export class OrderCargoBarcodesListPage extends React.Component {
  render() {
    return <OrderCargoBarcodesListPageContainer {...this.props} />;
  }
}
